var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workspaces"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9961 23.9996C21.9961 25.7662 21.2294 27.3662 19.9961 28.4662C18.9294 29.4329 17.5294 29.9996 15.9961 29.9996C12.6794 29.9996 9.99609 27.3162 9.99609 23.9996C9.99609 21.2329 11.8795 18.8996 14.4128 18.2162C15.0961 19.9496 16.5794 21.2996 18.4127 21.7996C18.9127 21.9329 19.4461 22.0162 19.9961 22.0162C20.5461 22.0162 21.0794 21.9496 21.5794 21.7996C21.8461 22.4663 21.9961 23.2162 21.9961 23.9996Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.998 16C25.998 16.7833 25.848 17.5333 25.5813 18.2167C24.898 19.95 23.4147 21.3 21.5814 21.8C21.0814 21.9333 20.548 22.0167 19.998 22.0167C19.448 22.0167 18.9147 21.95 18.4147 21.8C16.5813 21.3 15.098 19.9667 14.4147 18.2167C14.148 17.5333 13.998 16.7833 13.998 16C13.998 12.6833 16.6813 10 19.998 10C23.3147 10 25.998 12.6833 25.998 16Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.9961 23.9998C29.9961 27.3164 27.3128 29.9998 23.9961 29.9998C22.4628 29.9998 21.0628 29.4164 19.9961 28.4664C21.2294 27.3831 21.9961 25.7831 21.9961 23.9998C21.9961 23.2164 21.8461 22.4664 21.5794 21.7831C23.4128 21.2831 24.8961 19.9498 25.5794 18.1998C28.1127 18.8998 29.9961 21.2331 29.9961 23.9998Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.9987 36.6668H24.9987C33.332 36.6668 36.6654 33.3335 36.6654 25.0002V15.0002C36.6654 6.66683 33.332 3.3335 24.9987 3.3335H14.9987C6.66536 3.3335 3.33203 6.66683 3.33203 15.0002V25.0002C3.33203 33.3335 6.66536 36.6668 14.9987 36.6668Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceBlack);
export default __webpack_public_path__ + "static/media/workspace_black.0af115fa769eb820c0346d8b8b1e6c88.svg";
export { ForwardRef as ReactComponent };